const MarketingStatusBadge = ({ status }: { status: string }) => {
  const statusStyles: Record<string, string> = {
    draft: "bg-yellow-100 text-yellow-800",
    scheduled: "bg-orange-100 text-orange-800",
    published: "bg-green-100 text-green-800",
    processing: "bg-violet-100 text-violet-800",
    completed: "bg-blue-100 text-blue-800",
    failed: "bg-red-100 text-red-800",
  };

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium uppercase ${statusStyles[status]}`}
    >
      {status}
    </span>
  );
};

export default MarketingStatusBadge;